<template>
    <v-row>
        <v-col cols="12" md="5">
            <span class="text-body-2 font-weight-normal">{{ attribute.label }}</span>
            <v-autocomplete
                :value="selectedItems"
                :items="items"
                color="grey"
                item-color="grey"
                item-text="name"
                item-value="id"
                :disabled="items.length === 0 || withoutProblems"
                :label="$t('chooseVariants')"
                multiple
                chips
                hide-details
                :rules="rules"
                @change="setFilter"
            >
                <template v-slot:selection="data"></template>
                <template v-slot:prepend-item>
                    <v-list-item
                        ripple
                        @click="toggleSelectAll"
                    >
                        <v-list-item-action>
                            <v-icon >{{ icon }}</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>{{ $t('selectAll') }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2"></v-divider>
                </template>
            </v-autocomplete>
        </v-col>
        <v-col cols="12" md="7">
            <v-checkbox
                v-model="withoutProblems"
                color="yellow darken-1"
                :label="$t('withoutProblems')"
            ></v-checkbox>
        </v-col>
        <v-col cols="12">
            <v-chip
                v-for="(value, idx) in selectedItems"
                :key="idx"
                class="ma-2"
                close
                @click:close="removeItem(value)"
            >{{ getValueName(value) }}</v-chip>
        </v-col>
    </v-row>
</template>

<script>
import CalculatorDataProvider from "../../../../app-front/mixins/CalculatorDataProvider";

export default {
    name: "AttributeItem",
    mixins: [CalculatorDataProvider],
    props: ['attribute', 'calculationIdx', 'treatmentIdx', 'drugIdx'],
    data() {
        return {
            selectAll: false,
            withoutProblems: false,
            rules: [value => !!value || this.$t('requiredField')],
        }
    },
    computed: {
        items() {
            return this.attribute.valuesData || [];
        },
        selectedItems() {
            const drug = this.getDrug(this.calculationIdx, this.treatmentIdx, this.drugIdx)
            const filter = drug.filters[this.attribute.model]
            return filter ? filter : [];
        },
        allSelected() {
            return this.selectedItems.length === this.items.length;
        },
        icon () {
            return this.allSelected ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline';
        },
    },
    methods: {
        setFilter(data) {
            const filter = {
                name: this.attribute.model,
                values: data
            }
            this.setDrugFilter(filter, this.calculationIdx, this.treatmentIdx, this.drugIdx);
        },
        getValueName(valueId) {
            const value = this.attribute.valuesData.find(item => item.id === valueId);
            return value ? value.name : '-';
        },
        removeItem(valueId) {
            this.deleteFilterValue(this.calculationIdx, this.treatmentIdx, this.drugIdx, this.attribute.model, valueId)
        },
        toggleSelectAll() {
            if(!this.allSelected) {
                const allItems = this.items.map(item => item.id)
                this.setFilter(allItems);
            } else {
                this.setFilter([]);
            }
        }
    },
    watch: {
        withoutProblems(val) {
            if (val) this.setFilter([]);
        }
    }
}
</script>

<style scoped>

</style>
